import { pathOr } from 'ramda'
import * as AppActions from '../consts/actions'
import {
  CANCEL_EDIT_RESERVATION_SUCCESS,
  START_EDIT_RESERVATION_SUCCESS,
} from '../services/reservation/consts/reservation'

const initialState = ''

const userNeedToPayAfterEdit = (state = initialState, action) => {
  switch (action.type) {
    case AppActions.USER_NEED_TO_PAY: {
      return pathOr(state, ['payload'], action)
    }
    // A new or cancelled edit session owes nothing yet. Keeping the amount of the previous finish
    // left the payment block on screen over a session that had not been finished, and the block
    // then rendered whatever a stale price difference said. Trello WX7ttToD.
    case START_EDIT_RESERVATION_SUCCESS:
    case CANCEL_EDIT_RESERVATION_SUCCESS: {
      return initialState
    }
    default:
      return state
  }
}

/**
 * How much the customer still owes for the finished modification. This is the amount the finish
 * itself computed from the reservation's `toPayAmount`, not a difference between two reservation
 * snapshots: subtracting snapshots collapsed to 0 as soon as the customer re-entered the edit
 * screen, because both snapshots then carried the same pending modification. Trello WX7ttToD.
 */
export const getAmountToPayAfterEdit = (state) => Number(pathOr(0, ['userNeedToPayAfterEdit'], state)) || 0

export default userNeedToPayAfterEdit
